<template>
  <div class="content">
    <div class="tableTit">
      <p class="tabtitBg"></p>
      <h6>基本情况</h6>
      <el-button class="titBtn" v-if="bjdelShow==true" type="warning" icon="el-icon-delete" @click="deleteClick()">
        删除
      </el-button>
      <!-- 导入数据统计分析 -->
      <el-button class="titBtn" type="primary" icon="el-icon-pie-chart" @click="statisticAnalysis()">统计分析
      </el-button>

      <el-dropdown class="titBtn">
        <el-button type="primary">
          更多导入<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-if="isHiddenYjdc===true">
            淤积专项导入
            <input type="file" style="position: absolute;left: 0px;opacity: 0;z-index: 1;height: 100%;width: 100%;"
                   @change="xzdata($event)"/>
          </el-dropdown-item>
          <el-dropdown-item>
            小型坝导入
            <input type="file" style="position: absolute;left: 0px;opacity: 0;z-index: 1;height: 100%;width: 100%;"
                   @change="xxYdbImportdata($event)"/>
          </el-dropdown-item>
          <el-dropdown-item>
            PDF一坝一单导入
            <input style="position: absolute;left: 0px;opacity: 0;z-index: 1;height: 100%;width: 100%;"
                   @click="filterDataybyd()"/>
          </el-dropdown-item>
          <el-dropdown-item>
            淤地坝图片导入
            <input style="position: absolute;left: 0px;opacity: 0;z-index: 1;height: 100%;width: 100%;"
                   @click="ydbPhotoImport()"/>
          </el-dropdown-item>
          <el-dropdown-item>
            文件夹附件导入
            <input style="position: absolute;left: 0px;opacity: 0;z-index: 1;height: 100%;width: 100%;"
                   @click="folderImoprt()"/>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown class="titBtn" @command="downloadClick">
        <el-button type="primary">
          更多导出<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="3">淤积专项导出</el-dropdown-item>
          <el-dropdown-item command="4">小型坝模板导出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-button class="titBtn" icon="el-icon-upload" type="primary" @click="filterDataybyd()">PDF一坝一单导入</el-button> -->
      <div class="loading-overlay" v-if="loadingVisible">
        <el-progress type="circle" :percentage="loadingPercentage" :stroke-width="20"></el-progress>
        <p class="tips_css">{{ flag ? '数据正在更新中，请稍后...' : '数据正在导出中，请稍后...' }}</p>
      </div>
      <el-button class="titBtn" icon="el-icon-more" type="success" @click="filterData()">多条件查询</el-button>
      <!-- <el-button class="titBtn" type="success" icon="el-icon-download" @click="download">模板下载</el-button> -->
      <el-button class="titBtn" type="success" icon="el-icon-search" @click="search">搜索</el-button>

      <addressTree @obj="objdata" @close="treeClose"></addressTree>
      <el-button class="titBtn" type="primary" icon="el-icon-download" @click="downloadClick(2)">导出</el-button>
      <!-- <el-button class="titBtn" type="primary" icon="el-icon-download" @click="downloadClick(3)">淤积专项导出</el-button>这里将按钮整理到下拉菜单中 -->
      <el-button class="titBtn" type="primary" icon="el-icon-download" @click="downloadClick(1)">全部导出</el-button>

    </div>

    <div class="tabBody">
      <el-table ref="multipleTable" @selection-change="handleSelectionChange" :header-cell-style="rowClass"
                :data="tabledata" :height="tableHeight" border>
        <el-table-column type="selection" width="40" fixed="left"></el-table-column>
        <el-table-column align='center' label="2022年中型以上淤地坝风险隐患排查基本数据">
          <el-table-column type="index" align='center' width="45" label="序号" fixed="left"></el-table-column>
          <el-table-column prop="ydbSheng" align='center' label="省"></el-table-column>
          <el-table-column prop="ydbShi" align='center' label="市"></el-table-column>
          <el-table-column prop="ydbXian" align='center' label="县"></el-table-column>
          <el-table-column prop="ydbXiang" align='center' label="乡"></el-table-column>
          <el-table-column prop="ydbCun" align='center' label="村"></el-table-column>
          <el-table-column prop="ydbName" width="100" align='center' label="淤地坝名称"></el-table-column>
          <el-table-column prop="ydbCode" width="180" align='center' label="编码"></el-table-column>
          <el-table-column prop="ydbSfwggb" align='center' label="类型"></el-table-column>
          <el-table-column prop="ydbSnzc" width="100" align='center' label="枢纽组成"></el-table-column>
          <el-table-column prop="ydbSszl" align='center' label="所在支流"></el-table-column>
          <el-table-column prop="ydbJcnd" align='center' label="建成年代"></el-table-column>
          <el-table-column prop="ydbKzmj" width="110" align='center' label="控制面积(km²)"></el-table-column>
          <el-table-column prop="ydbBaGao" align='center' label="坝高(m)"></el-table-column>
          <el-table-column prop="ydbBdcd" align='center' label="坝顶长(m)"></el-table-column>
          <el-table-column prop="ydbZkr" width="100" align='center' label="总库容(万m³)"></el-table-column>
          <el-table-column prop="ydbDhkr" width="110" align='center' label="滞洪库容(万m³)"></el-table-column>
          <el-table-column prop="ydbSjyjkr" width="100" align='center' label="设计淤积库容(万m³)"></el-table-column>
          <el-table-column prop="ydbYykr" width="110" align='center' label="已淤库容(万m³)"></el-table-column>
          <el-table-column prop="ydbSjyjmj" width="130" align='center' label="设计淤地面积(hm²)"></el-table-column>
          <el-table-column prop="ydbYyjmj" width="120" align='center' label="已淤地面积(hm²)"></el-table-column>
          <el-table-column align='center' label="地理坐标">
            <el-table-column prop="ydbJingDu" width="140" align='center' label="经度"></el-table-column>
            <el-table-column prop="ydbWeiDu" width="140" align='center' label="纬度"></el-table-column>
          </el-table-column>
          <el-table-column prop="ydbSfgj" align='center' label="是否改建">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbSfgj=='0'">否</p>
              <p v-if="scope.row.ydbSfgj=='1'">是</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbSfcxjg" width="100" align='center' label="是否除险加固">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbSfcxjg=='0'">否</p>
              <p v-if="scope.row.ydbSfcxjg=='1'">是</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbSfljb" width="90" align='center' label="是否老旧坝">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbSfljb=='0'">否</p>
              <p v-if="scope.row.ydbSfljb=='1'">是</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbBxsltj" width="90" align='center' label="是否病险坝">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbBxsltj=='0'">否</p>
              <p v-if="scope.row.ydbBxsltj!='0'">是</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbSfxygzsj" width="110" align='center' label="是否需改造提升">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbSfxygzsj=='0'">否</p>
              <p v-if="scope.row.ydbSfxygzsj=='1'">是</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbSfxyxsly" width="110" align='center' label="是否需蓄水利用">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbSfxyxsly=='0'">否</p>
              <p v-if="scope.row.ydbSfxyxsly=='1'">是</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbSfbzyhgbyt" width="142" align='center' label="是否被占用或改变用途">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbSfbzyhgbyt=='0'">否</p>
              <p v-if="scope.row.ydbSfbzyhgbyt=='1'">是</p>
            </template>
          </el-table-column>
          <el-table-column prop="delFlag" width="100" align='center' label="是否已销号">
            <template slot-scope="scope">
              <p v-if="scope.row.delFlag=='0'">否</p>
              <p v-if="scope.row.delFlag=='1'">是</p>
            </template>
          </el-table-column>
          <el-table-column align='center' label="坝体病险情况">
            <el-table-column prop="ydbBtlf" align='center' label="裂缝">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbBtlf=='0'">否</p>
                <p v-if="scope.row.ydbBtlf=='1'">是</p>
              </template>
            </el-table-column>
            <el-table-column prop="ydbBthptt" align='center' label="滑坡坍塌">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbBthptt=='0'">否</p>
                <p v-if="scope.row.ydbBthptt=='1'">是</p>
              </template>
            </el-table-column>
            <el-table-column prop="ydbBtcqcg" align='center' label="冲缺冲沟">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbBtcqcg=='0'">否</p>
                <p v-if="scope.row.ydbBtcqcg=='1'">是</p>
              </template>
            </el-table-column>
            <el-table-column prop="ydbBtgysl" align='center' label="管涌,渗漏">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbBtgysl=='0'">否</p>
                <p v-if="scope.row.ydbBtgysl=='1'">是</p>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align='center' label="放水建筑物病险情况">
            <el-table-column prop="ybdFsjzwwgsj" align='center' label="卧管,竖井">
              <template slot-scope="scope">
                <p v-if="scope.row.ybdFsjzwwgsj=='0'">否</p>
                <p v-if="scope.row.ybdFsjzwwgsj=='1'">是</p>
              </template>
            </el-table-column>
            <el-table-column prop="ydbFsjzwhdhg" align='center' label="涵洞,涵管">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbFsjzwhdhg=='0'">否</p>
                <p v-if="scope.row.ydbFsjzwhdhg=='1'">是</p>
              </template>
            </el-table-column>
            <el-table-column prop="ydbFsjzwmq" align='center' label="明渠">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbFsjzwmq=='0'">否</p>
                <p v-if="scope.row.ydbFsjzwmq=='1'">是</p>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align='center' label="泄水建筑物病险情况">
            <el-table-column prop="ydbXsjzwmq" align='center' label="损毁">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbXsjzwmq=='0'">否</p>
                <p v-if="scope.row.ydbXsjzwmq=='1'">是</p>
              </template>
            </el-table-column>
            <el-table-column prop="ydbXsjzwtsxk" align='center' label="淘刷,悬空">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbXsjzwtsxk=='0'">否</p>
                <p v-if="scope.row.ydbXsjzwtsxk=='1'">是</p>
              </template>
            </el-table-column>
            <el-table-column prop="ydbXsjzwqt" align='center' label="其他">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbXsjzwqt=='0'">否</p>
                <p v-if="scope.row.ydbXsjzwqt=='1'">是</p>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align='center' label="其他安全隐患">
            <el-table-column prop="ydbDlbt" align='center' label="道路不通">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbDlbt=='0'">否</p>
                <p v-if="scope.row.ydbDlbt=='1'">是</p>
              </template>
            </el-table-column>
            <el-table-column prop="ydbLabpbwd" width="110" align='center' label="两岸边坡不稳定">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbLabpbwd=='0'">否</p>
                <p v-if="scope.row.ydbLabpbwd=='1'">是</p>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column prop="ydbYxrs" align='center' label="影响人数"></el-table-column>
          <el-table-column prop="ydbZyss" width="150" align='center' label="重要设施"></el-table-column>
          <el-table-column prop="ydbJkss" width="80" align='center' label="监控设施"></el-table-column>
          <el-table-column prop="ydbGlzrzt" width="100" align='center' label="管理责任主体"></el-table-column>
          <el-table-column prop="ydbYwghbc" align='center' label="管护报酬"></el-table-column>
          <el-table-column prop="ydbQtwtsm" width="140" align='center' label="其他需要说明的问题"></el-table-column>
          <el-table-column prop="ydbSfxyyr" width="100" align='center' label="是否下游有人">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbSfxyyr=='0'">否</p>
              <p v-if="scope.row.ydbSfxyyr=='1'">是</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbSfyzyss" width="110" align='center' label="是否有重要设施">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbSfyzyss=='0'">否</p>
              <p v-if="scope.row.ydbSfyzyss=='1'">是</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbSfbwfys" width="110" align='center' label="是否百万方以上">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbSfbwfys=='0'">否</p>
              <p v-if="scope.row.ydbSfbwfys=='1'">是</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbClbCode" width="180" align='center' label="串联坝编码"></el-table-column>
          <el-table-column prop="ydbSzxly" align='center' label="所在小流域"></el-table-column>
          <el-table-column prop="ydbFxjb" align='center' label="风险级别"></el-table-column>
          <el-table-column prop="ydbSfwclb" width="142" align='center' label="是否为串联坝">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbSfwclb=='1'">是</p>
              <p v-else>否</p>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column align='center' label="2024年中型以上淤地坝淤积专项调查基本数据">
          <el-table-column prop="ydbBkmj" width="120" align='center' label="坝控面积(km²)"></el-table-column>
          <el-table-column align='center' label="淤积调查地理坐标(采用CGCS2000国家大地坐标系)">
            <el-table-column prop="ydbYjdcjd" width="140" align='center' label="经度"></el-table-column>
            <el-table-column prop="ydbYjdcwd" width="140" align='center' label="纬度"></el-table-column>
          </el-table-column>
          <el-table-column align='center' label="基于卫星遥感/无人机影像获取的指标成果">
            <el-table-column prop="ydbYxsjly" width="100" align='center' label="数据来源">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbYxsjly=='0'">卫星遥感影像</p>
                <p v-if="scope.row.ydbYxsjly=='1'">无人机影像</p>
              </template>
            </el-table-column>
            <el-table-column prop="ydbYxgcjz" width="110" align='center' label="高程基准">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbYxgcjz=='0'">大地高程</p>
                <p v-if="scope.row.ydbYxgcjz=='1'">85高程</p>
              </template>
            </el-table-column>
            <el-table-column prop="ydbYxyymj" width="200" align='center'
                             label="已淤面积（h㎡）（无水坝淤积面积/有水坝水面或水面与出露淤积面整体面积）"></el-table-column>
            <el-table-column prop="ydbYxsykr" width="200" align='center'
                             label="无水坝淤积面/有水坝水面或水面与出露淤积面整体到坝顶的容积（万m³）（不含水体体积）"></el-table-column>
            <el-table-column prop="ydbYxyykr" width="110" align='center'
                             label="已淤库容(万m³)(不含水体体积)"></el-table-column>
            <el-table-column prop="ydbYxxskr" width="150" align='center'
                             label="水体体积(万m³)(有水淤地坝的水的体积)"></el-table-column>
            <el-table-column prop="ydbYxbdgc" width="110" align='center' label="坝顶高程(m)(坝顶平均高程值)">
            </el-table-column>
            <el-table-column prop="ydbYxyjgc" width="200" align='center'
                             label="无水坝淤积面平均高程/有水坝水面或水面与出露淤积面整体平均高程（m）"></el-table-column>
            <el-table-column prop="ydbYxxhssgc" width="200" align='center'
                             label="泄洪设施高程(m)(泄洪设施进口段横断面平均高程值)"></el-table-column>
            <el-table-column prop="ydbYxbtbsmbjgc" width="200" align='center'
                             label="坝体背水面坝脚高程(m)(坝体背水面与下游连接处沟底高程)"></el-table-column>
            <el-table-column prop="ydbYxsjjsryxm" width="110" align='center' label="数据计算人员姓名"></el-table-column>
            <el-table-column prop="ydbYxsjjsrylxfs" width="110" align='center'
                             label="数据计算人员联系方式"></el-table-column>
          </el-table-column>
          <el-table-column align='center' label="RTK/无人船声呐技术实测获取的指标成果">
            <el-table-column prop="ydbScsjly" align='center' label="数据来源">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbScsjly=='0'">RTK测量</p>
                <p v-if="scope.row.ydbScsjly=='1'">RTK测量辅助无人船声呐技术</p>
                <p v-if="scope.row.ydbScsjly=='2'">无人机航测辅助无人船声呐技术</p>
              </template>
            </el-table-column>
            <el-table-column prop="ydbScgcjz" width="110" align='center' label="高程基准">
              <template slot-scope="scope">
                <p v-if="scope.row.ydbScgcjz=='0'">大地高程</p>
                <p v-if="scope.row.ydbScgcjz=='1'">85高程</p>
              </template>
            </el-table-column>
            <el-table-column prop="ydbScbtgc" width="150" align='center'
                             label="坝顶高程(m)(坝顶各测点高程平均值)"></el-table-column>
            <el-table-column prop="ydbScyjgc" width="200" align='center'
                             label="无水坝淤积面各测点平均高程/有水坝水面或水面与出露淤积面整体各测点平均高程（m）"></el-table-column>
            <el-table-column prop="ydbScstsd" width="150" align='center'
                             label="水体深度(m)(有水淤地坝水深平均值)"></el-table-column>
            <el-table-column prop="ydbScxhssgd" width="150" align='center'
                             label="泄洪设施高程(m)(泄洪设施进口段各测点平均高程值)"></el-table-column>
            <el-table-column prop="ydbScbtbsmbjgc" width="180" align='center'
                             label="坝体背水面坝脚高程(m)(坝体背水面与下游连接处沟底测点高程平均值)"></el-table-column>
            <el-table-column prop="ydbScgccjryxm" width="120" align='center' label="高程采集人员姓名"></el-table-column>
            <el-table-column prop="ydbScgccjrylxfs" width="150" align='center'
                             label="高程采集人员联系方式"></el-table-column>
            <el-table-column prop="ydbScgccjsj" width="110" align='center' label="高程采集时间"></el-table-column>
          </el-table-column>
          <el-table-column prop="ydbSf12788sj" width="110" align='center' label="是否16788数据">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbSf16788sj=='0'">否</p>
              <p v-if="scope.row.ydbSf16788sj=='1'">是</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbTsqkydb" width="110" align='center' label="特殊情况淤地坝">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbTsqkydb=='0'">淤地坝损毁</p>
              <p v-if="scope.row.ydbTsqkydb=='1'">位置信息错误找不见坝</p>
              <p v-if="scope.row.ydbTsqkydb=='2'">位置信息重复找不见坝</p>
              <p v-if="scope.row.ydbTsqkydb=='3'">人为活动占用</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbYjqk" width="110" align='center' label="淤积情况">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbYjqk=='0'">完全淤平</p>
              <p v-if="scope.row.ydbYjqk=='1'">接近淤满</p>
              <p v-if="scope.row.ydbYjqk=='2'">未淤满</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbSxyysgdwfhq" width="180" align='center' label="上下游原始沟底高程无法获取">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbSxyysgdwfhq=='0'">坝系，采用坝高已修正</p>
              <p v-if="scope.row.ydbSxyysgdwfhq=='1'">坝系，无法修正</p>
              <p v-if="scope.row.ydbSxyysgdwfhq=='2'">其他，采用坝高已修正</p>
              <p v-if="scope.row.ydbSxyysgdwfhq=='3'">其他，无法修正</p>
            </template>
          </el-table-column>
          <el-table-column prop="ydbBppdsfzqhq" width="150" align='center' label="边坡坡度是否准确获取">
            <template slot-scope="scope">
              <p v-if="scope.row.ydbBppdsfzqhq=='0'">是</p>
              <p v-if="scope.row.ydbBppdsfzqhq=='1'">否</p>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="hasRainDevice" width="150" align='center' label="是否存在雨量计监测设备">
            <template slot-scope="scope">
                <p v-if="scope.row.hasRainDevice=='1'">是</p>
                <p v-if="scope.row.hasRainDevice=='0'">否</p>
              </template>
          </el-table-column>
          <el-table-column prop="hasWaterDevice" width="150" align='center' label="是否存在水位计监测设备">
            <template slot-scope="scope">
                <p v-if="scope.row.hasWaterDevice=='1'">是</p>
                <p v-if="scope.row.hasWaterDevice=='0'">否</p>
              </template>
          </el-table-column>
          <el-table-column prop="hasWeiyiDevice" width="150" align='center' label="是否存在位移监测设备">
            <template slot-scope="scope">
                <p v-if="scope.row.hasWeiyiDevice=='1'">是</p>
                <p v-if="scope.row.hasWeiyiDevice=='0'">否</p>
              </template>
          </el-table-column>
          <el-table-column prop="hasvideoDevice" width="150" align='center' label="是否存在视频监控设备">
            <template slot-scope="scope">
                <p v-if="scope.row.hasvideoDevice=='1'">是</p>
                <p v-if="scope.row.hasvideoDevice=='0'">否</p>
              </template>
          </el-table-column> -->
          <el-table-column prop="remark" width="200" align='center' label="备注"></el-table-column>


          <el-table-column prop="ydbPdfName" label="PDF附件">

            <template #default="scope">
              <span @click="handleRowClick(scope.row.ydbPdfSourceName)" class="table-btn btn-handle"><i
               class="ri-eye-line"></i><a :style="{ color: 'blue' }">{{ scope.row.ydbPdfName }}</a></span>
              <!-- <span @click="handleDownLoadClick(scope.row)" class="table-btn btn-handle"><i class="ri-download-2-line"></i>下载</span> -->
            </template>
          </el-table-column>

          <el-table-column prop="ydbAttachPath" width="90" label="文件夹附件">
            <template #default="scope">
              <span @click="handleAttachRowClick(scope.row.ydbAttachPath)" class="table-btn btn-handle"><i
               class="ri-eye-line"></i><a :style="{ color: 'blue' }">{{ scope.row.ydbAttachPath }}</a></span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column prop="" fixed="right" label="操作" width="130" align="center">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-download" class="tableedit" round
                       @click='downloadrow(scope.$index,scope.row)'></el-button>
            <el-button type="success" icon="el-icon-edit" circle @click="edit(scope.$index,scope.row)" class="btnmargin"
                       v-if="bjdelShow==true" :disabled="scope.row.delFlag === 1"></el-button>
            <el-button type="primary" icon="el-icon-view" circle @click="See(scope.$index,scope.row)"
                       class="btnmargin"></el-button>
            <el-button type="primary" icon="el-icon-video-play" circle @click="video(scope.$index,scope.row)"
                       class="btnmargin"></el-button>
            <!-- <el-button type="primary" icon="el-icon-folder-add" class="tableedit" round @click='uploadFold(scope.$index,scope.row)'></el-button> -->
            <!-- <el-button type="warning" icon="el-icon-delete" circle @click="deletes(scope.$index,scope.row)" class="btnmargin"></el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
     title="预览"
     :visible.sync="PreviewDialogVisible"
     append-to-body
     width="70%"
     :style="{ 'position': 'fixed'}"
     center
     :before-close="closePdf"
    >
      <div>
        <iframe ref="pdfIframe" :src="pdfSrc" width="100%" height="600px" id="iframe"></iframe>
      </div>
    </el-dialog>

    <div class="fye">
      <pagintion ref="mypagintion" @dsydata='DsyData' @dstdata="DstData" :total='total'
                 :pageNums="pageNums"></pagintion>
    </div>

    <registerXzpopup v-if="dialogVisible == true" :mystate="Addsid" @bjadddata="Bjadddata" @getcancel="Getcancel">
    </registerXzpopup>
    <fjpopup v-if="fjdialogVisible == true" :mystate="Addsid" @getcancel="fjGetcancel">
    </fjpopup>
    <!-- 条件筛选的弹出框组件 -->
    <filterpopup v-if="filterDialogVisible == true" @getfiltercancel="getFilterCancel"
                 @conditionSearch="conditionSearch"></filterpopup>
    <!-- 淤积调查导入结果提示 -->
    <yjdcimporterrorpopup v-if="importErrorDialogVisible == true" @yjdcimporterrorcancel="yjdcDialogClose"
                          :errordatas="errordatas"></yjdcimporterrorpopup>
    <!-- 一坝一单导入的弹出框组件 -->
    <yibayidanpopup v-if="filterDialogVisibleybyd == true" @getpdfcancel="getpdfcancel"
                    @conditionSearch="conditionSearch"></yibayidanpopup>
    <!-- 淤地坝图片导入的弹出框组件 -->
    <ydbphotopopup v-if="ydbPhotoImportDialogVisible == true" @getydbphotocancel="getydbphotocancel"
                    @conditionSearch="conditionSearch"></ydbphotopopup>
    <!--销号凭证弹出框-->
    <xhpzpopup v-if="filterDialogVisiblexhpz == true" @getxhpzpdfcancel="getxhpzpdfcancel"
               @uploadxhpzToDele="uploadxhpzToDele" @conditionSearch="conditionSearch"></xhpzpopup>
    <!-- 统计分析 -->
    <importstatisticanalysis v-if="statisticDialogVisible == true"
                             @getStatisticcancel="getStatisticCancel"></importstatisticanalysis>
    <!-- 文件夹导入 -->
    <importfolderdialog v-if="floderImportDialogVisible == true" @folderimportcancel="folderImportDialogCancel"
                        :title="title" :isHiddenUploadDiv="isHiddenUploadDiv" :dirName="dirName"></importfolderdialog>

  </div>
</template>
<script>
import addressTree from '@/components/mangement/addressTree.vue'
import pagintion from '@/components/mangement/pagintion.vue'
import { Progress } from 'element-ui'
import registerXzpopup from '../popup/registerXzpopup.vue'
import filterpopup from '../popup/filterpopup.vue'
import yibayidanpopup from '../popup/yibayidanpopup.vue'
import ydbphotopopup from '../popup/ydbphotopopup.vue'
import xhpzpopup from '../popup/xhpzpopup.vue'
import fjpopup from '../popup/fjpopup.vue'
import Url from '@/common/js/Url.js'
import axios from 'axios'
import yjdcimporterrorpopup from '../popup/yjdcimporterror.vue'
import importstatisticanalysis from '../popup/importstatisticanalysis.vue'
import importfolderdialog from '../popup/importfolderdialog.vue'

import {
  selectYdbInfo,
  ydbdeleteYdbInfo,
  preApproveYdb
} from '@/api/api.js'

export default {
  data () {
    return {
      title: '',
      tableHeight: window.innerHeight - 180,
      tabledata: [],
      total: null,
      pageSize: 20, //每页多少条数据分页
      pageNum: 1, //当前页
      pageNums: null,
      multipleSelection: [],
      dialogVisible: false,
      fjdialogVisible: false,
      filterDialogVisible: false,
      filterDialogVisibleybyd: false,
      ydbPhotoImportDialogVisible: false,
      filterDialogVisiblexhpz: false,
      importErrorDialogVisible: false,
      errordatas: null,
      Addsid: [],
      loadingPercentage: 0,//进度百分比
      timer: null,//定时器
      loadingVisible: false,//开启遮罩
      objdata1: null,
      condition: null,
      bjdelShow: false,
      pdfSrc: '',
      PreviewDialogVisible: false,
      statisticDialogVisible: false,
      floderImportDialogVisible: false,
      flag: false,//数据导出
      isHiddenUploadDiv: true,
      dirName: '',
      isHiddenYjdc: true
    }

  },
  components: {
    addressTree,
    pagintion,
    registerXzpopup,
    'el-progress': Progress,
    fjpopup,
    filterpopup,
    yjdcimporterrorpopup,
    yibayidanpopup,
    ydbphotopopup,
    xhpzpopup,
    importstatisticanalysis,
    importfolderdialog
  },
  mounted () {
    let userId = this.$store.state.userid
    if (userId != 559) {
      this.isHiddenYjdc = false
    }

    if (this.$store.state.roleCode.indexOf('SUBMIT') != -1) {
      this.bjdelShow = true
    } else {
      this.bjdelShow = false
    }

    let params = {
      pageSize: this.pageSize,
      pageNum: this.pageNum,
      ydbName: this.objdata1
    }
    this.list(params)
  },
  methods: {
    folderImportDialogCancel () {
      this.dirName = ''
      this.floderImportDialogVisible = false

    },
    folderImoprt () {
      this.title = '文件夹附件导入'
      this.isHiddenUploadDiv = true
      this.floderImportDialogVisible = true

    },
    getStatisticCancel () {
      this.statisticDialogVisible = false
    },
    statisticAnalysis () {
      this.statisticDialogVisible = true
    },
    closePdf () {
      this.pdfSrc = ''
      this.PreviewDialogVisible = false
    },
    handleRowClick (row) {
      // 构建请求URL，包含Access-Token
      const url = `/userApi/minio/viewFile/${row}`
      // 构建请求头，包含Content-Type和Access-Token
      const headers = {
        'Access-Token': this.$store.state.token
      }

      fetch(url, {
        method: 'GET',
        headers: headers
      })
       .then(response => response.blob())
       .then(blob2 => {
         if (blob2 instanceof Blob) {
           // 创建一个a标签用于下载
           const blob = new Blob([blob2], { type: 'application/pdf' })
           this.pdfSrc = window.URL.createObjectURL(blob)
           this.$nextTick(() => {
             this.PreviewDialogVisible = true
           })
         } else {
           // 如果响应不是文件流，处理错误
           console.error('Response is not a file stream')
         }
       })
       .catch(error => console.error('下载失败：', error))
    },
    handleAttachRowClick (ydbAttachPath) {
      this.title = '文件夹信息'
      this.isHiddenUploadDiv = false
      this.dirName = ydbAttachPath
      this.floderImportDialogVisible = true
    },
    startLoading () {
      this.loadingVisible = true
      this.loadingPercentage = 0
      this.timer = setInterval(() => {
        if (this.loadingPercentage < 90) {
          this.loadingPercentage += 1
        }
      }, 5000)
    },
    Bjadddata () {
      this.dialogVisible = false
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1
      }
      this.list(params)
    },
    Getcancel () {
      this.dialogVisible = false
    },
    fjGetcancel () {
      this.fjdialogVisible = false
    },
    getFilterCancel () {
      this.filterDialogVisible = false
    },
    getpdfcancel () {
      this.filterDialogVisibleybyd = false
    },
    getydbphotocancel (){
      this.ydbPhotoImportDialogVisible = false
    },
    getxhpzpdfcancel () {
      this.filterDialogVisiblexhpz = false
    },
    uploadxhpzToDele (concatenatedString) {
      for (let i = 0; i < this.multipleSelection.length; i++) {
        this.multipleSelection[i].ydbLx = '销号'
        this.multipleSelection[i].attach = concatenatedString
      }
      preApproveYdb(this.multipleSelection).then((res) => {
        if (res.code === 200) {
          if(res.data.businessCode === 20002 || res.data.businessCode === 20001){
            this.$notify({
              title: '提示',
              message: res.data.message,
              type: 'error'
            });
          }else{
              this.$notify({
                title: '提示',
                message: '提交删除审核成功!',
                type: 'success'
              })
          }
        }
      }).catch(err => {
        // 处理上传请求的错误
        console.error(err)
        this.$notify({
          title: '提示',
          message: '暂无审批人!',
          type: 'error'
        })
      })
    },
    yjdcDialogClose () {
      this.importErrorDialogVisible = false
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    edit (index, row) {
      // this.Addsid = [row]
      this.Addsid = ['bj', row]
      this.dialogVisible = true
    },
    filterData () {
      this.filterDialogVisible = true
    },
    filterDataybyd () {
      this.filterDialogVisibleybyd = true
    },
    ydbPhotoImport (){
      this.ydbPhotoImportDialogVisible = true
    },
    //销号凭证
    filterDataxhpz () {
      this.filterDialogVisiblexhpz = true
    },
    See (index, row) {
      this.Addsid = ['ck', row]
      this.dialogVisible = true
    },
    uploadFold (index, row) {
      this.Addsid = ['bj', row]
      this.fjdialogVisible = true
      // window.location.href = '/userApi/ydb/basic/downYdbInfo?id=' + row.id;
    },
    downloadrow (index, row) {
      let ids = []
      ids.push(row.id)
      let strIds = ids.toString()
      // window.location.href = '/userApi/ydb/basic/downYdbInfo?ids=' + strIds;
      // let ids = [];
      // for (let i = 0; i < this.multipleSelection.length; i++) {
      //   ids.push(this.multipleSelection[i].id);
      // }
      // let strIds = ids.toString();
      // console.log(strIds);
      let params = {
        regionCode: this.$store.state.regionCode,
        ids: strIds
      }
      // 构建请求URL，包含Access-Token
      const url = `/userApi/ydb/basic/downYdbInfo`
      // 构建请求头，包含Content-Type和Access-Token
      const headers = {
        'Access-Token': this.$store.state.token
      }

      axios.get(url, {
        method: 'GET',
        headers,
        params,
        responseType: 'blob' // 设置响应类型为blob

      }).then(res => {

        // const blob = new Blob([res.data]);
        // const downloadUrl = window.URL.createObjectURL(blob);

        // const link = document.createElement("a");
        // link.href = downloadUrl;
        // link.download = downloadName+'.zip';
        // link.click();

        // window.URL.revokeObjectURL(downloadUrl);

        //创建一个虚拟的链接元素，模拟点击下载
        const link = document.createElement('a')
        let blob1 = new Blob([res.data], { type: 'application/octet-stream;' })
        link.href = window.URL.createObjectURL(blob1)

        link.download = '淤地坝数据淤地坝专项调查导出.xlsx' // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
        document.body.appendChild(link)
        // 模拟点击
        link.click()
        // 移除虚拟链接元素
        document.body.removeChild(link)
      })
       .catch(error => console.error('下载失败：', error))
      //window.location.href = '/userApi/ydb/basic/downYdbInfo?ids=' + strIds;

    },
    downloadClick (type) {
      if (type == 1) {
        this.flag = false
        //const regionCode = this.$store.state.regionCode
        // console.log('----------------------->', regionCode)
        //window.location.href = '/userApi/ydb/basic/downYdbInfo?regionCode=' + regionCode;
        let params = {
          regionCode: this.$store.state.regionCode
        }
        // 构建请求URL，包含Access-Token
        const url = `/userApi/ydb/basic/downYdbInfo`
        // 构建请求头，包含Content-Type和Access-Token
        const headers = {
          'Access-Token': this.$store.state.token
        }
        //const accessToken = 'this.$store.state.token';
        // const headers = new Headers();
        // headers.append('Authorization', `Bearer ${accessToken}`);
        this.laoding = true
        this.startLoading()
        axios.get(url, {
          method: 'GET',
          headers,
          params,
          responseType: 'blob' // 设置响应类型为blob

        }).then(res => {

          // const blob = new Blob([res.data]);
          // const downloadUrl = window.URL.createObjectURL(blob);

          // const link = document.createElement("a");
          // link.href = downloadUrl;
          // link.download = "downloadedFile.zip";
          // link.click();

          // window.URL.revokeObjectURL(downloadUrl);
          // 创建一个虚拟的链接元素，模拟点击下载
          const link = document.createElement('a')
          let blob1 = new Blob([res.data], { type: 'application/octet-stream;' })
          link.href = window.URL.createObjectURL(blob1)

          link.download = '淤地坝基础数据.xlsx' // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
          document.body.appendChild(link)
          // 模拟点击
          link.click()
          // 移除虚拟链接元素
          document.body.removeChild(link)
          clearInterval(this.timer) // 停止计时器
          this.loadingPercentage = 100
          // 延时 1 秒后执行关闭遮罩或其他操作
          setTimeout(() => {
            this.loadingVisible = false
          }, 1000)

        }).catch(error => {
          console.error('下载失败：', error)
          clearInterval(this.timer) // 停止计时器
          this.loadingPercentage = 100
          // 延时 1 秒后执行关闭遮罩或其他操作
          setTimeout(() => {
            this.loadingVisible = false
            // 关闭遮罩或执行其他操作
          }, 1000)
        })

      } else if (type == 3) {
        // const regionCode = this.$store.state.regionCode
        // window.location.href = '/userApi/ydb/basic/downYdbInfo?regionCode=' + regionCode+'&type=3' ;
        this.flag = false
        let params = {
          regionCode: this.$store.state.regionCode,
          type: 3
        }
        // 构建请求URL，包含Access-Token
        const url = `/userApi/ydb/basic/downYdbInfo`
        // 构建请求头，包含Content-Type和Access-Token
        const headers = {
          'Access-Token': this.$store.state.token
        }
        //const accessToken = 'this.$store.state.token';
        // const headers = new Headers();
        // headers.append('Authorization', `Bearer ${accessToken}`);

        this.laoding = true
        this.startLoading()
        axios.get(url, {
          method: 'GET',
          headers,
          params,
          responseType: 'blob' // 设置响应类型为blob

        }).then(res => {

          // const blob = new Blob([res.data]);
          // const downloadUrl = window.URL.createObjectURL(blob);

          // const link = document.createElement("a");
          // link.href = downloadUrl;
          // link.download = "downloadedFile.zip";
          // link.click();

          // window.URL.revokeObjectURL(downloadUrl);
          // 创建一个虚拟的链接元素，模拟点击下载
          const link = document.createElement('a')
          let blob1 = new Blob([res.data], { type: 'application/octet-stream;' })
          link.href = window.URL.createObjectURL(blob1)

          link.download = '淤地坝基础数据.xlsx' // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
          document.body.appendChild(link)
          // 模拟点击
          link.click()
          // 移除虚拟链接元素
          document.body.removeChild(link)
          clearInterval(this.timer) // 停止计时器
          this.loadingPercentage = 100
          // 延时 1 秒后执行关闭遮罩或其他操作
          setTimeout(() => {
            this.loadingVisible = false
          }, 1000)

        }).catch(error => {
          console.error('下载失败：', error)
          clearInterval(this.timer) // 停止计时器
          this.loadingPercentage = 100
          // 延时 1 秒后执行关闭遮罩或其他操作
          setTimeout(() => {
            this.loadingVisible = false
            // 关闭遮罩或执行其他操作
          }, 1000)
        })

      } else if (type == 4) {
        this.flag = false
        window.location.href = '/userApi/ydb/basic/export?type=1'
      } else {
        this.flag = false
        if (this.multipleSelection.length == 0) {
          this.$notify({
            title: '提示',
            message: '请选择要下载的数据！',
            type: 'warning'
          })
        } else {
          let ids = []
          for (let i = 0; i < this.multipleSelection.length; i++) {
            ids.push(this.multipleSelection[i].id)
          }
          let strIds = ids.toString()
          console.log(strIds)
          let params = {
            regionCode: this.$store.state.regionCode,
            ids: strIds
          }
          // 构建请求URL，包含Access-Token
          const url = `/userApi/ydb/basic/downYdbInfo`
          // 构建请求头，包含Content-Type和Access-Token
          const headers = {
            'Access-Token': this.$store.state.token
          }

          this.laoding = true
          this.startLoading()
          axios.get(url, {
            method: 'GET',
            headers,
            params,
            responseType: 'blob' // 设置响应类型为blob

          }).then(res => {

            // const blob = new Blob([res.data]);
            // const downloadUrl = window.URL.createObjectURL(blob);

            // const link = document.createElement("a");
            // link.href = downloadUrl;
            // link.download = downloadName+'.zip';
            // link.click();

            // window.URL.revokeObjectURL(downloadUrl);

            //创建一个虚拟的链接元素，模拟点击下载
            const link = document.createElement('a')
            let blob1 = new Blob([res.data], { type: 'application/octet-stream;' })
            link.href = window.URL.createObjectURL(blob1)

            link.download = '淤堤坝基础数据.xlsx' // 设置下载文件名，替换filename.ext为实际的文件名和扩展名
            document.body.appendChild(link)
            // 模拟点击
            link.click()
            // 移除虚拟链接元素
            document.body.removeChild(link)
            clearInterval(this.timer) // 停止计时器
            this.loadingPercentage = 100
            // 延时 1 秒后执行关闭遮罩或其他操作
            setTimeout(() => {
              this.loadingVisible = false
            }, 1000)
          })
           .catch(error => console.error('下载失败：', error))
          clearInterval(this.timer) // 停止计时器
          this.loadingPercentage = 100
          // 延时 1 秒后执行关闭遮罩或其他操作
          setTimeout(() => {
            this.loadingVisible = false
            // 关闭遮罩或执行其他操作
          }, 1000)

          //window.location.href = '/userApi/ydb/basic/downYdbInfo?ids=' + strIds;
        }
      }
    },
    treeClose () {
      this.objdata1 = null
      this.total = null
      let params = {
        pageSize: this.pageSize,
        pageNum: 1,
        ydbName: this.objdata1
      }
      this.list(params)
    },
    search () {
      this.tabledata = []
      this.total = null
      let params = {
        pageSize: this.pageSize,
        pageNum: 1,
        ydbName: this.objdata1
      }
      this.list(params)
    },
    conditionSearch (condition) {
      this.pageNum = 1
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      this.condition = condition
      let requestParams = { ...params, ...condition }
      console.log('requestParams', requestParams)
      this.list(requestParams)
    },
    objdata (data) {
      this.objdata1 = data
    },
    DsyData (data) { //多少页
      this.pageNum = data.dsy
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1
      }
      let requestParams = { ...params, ...this.condition }
      this.list(requestParams)
    },
    DstData (data) { //多少条
      this.pageSize = data.dst
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        ydbName: this.objdata1
      }
      let requestParams = { ...params, ...this.condition }
      this.list(requestParams)
    },
    download () {
      window.location.href = '/userApi/ydb/basic/export'
    },

    list(params) {
      this.tabledata = []
      selectYdbInfo(params).then((res) => {
        // console.log(res.data)
        if (this.$store.state.regionCode === '000000' && !params.ydbShengCode &&!params.ydbXianCode && !params.ydbShiCode) {
          this.total = res.total 
        } else {
          this.total = res.total
        }
        this.tabledata = res.data
      })
    },
    deleteClick () {
      const delFlag = this.multipleSelection[0].delFlag;
      if(1===delFlag){
        this.$message({
          message:'已销号数据不能继续销号',
          type:'warning'
        })
        return;
      }
      let _this = this
      if (this.multipleSelection.length == 0) {
        this.$notify({
          title: '提示',
          message: '请选择要提交删除审核的数据！',
          type: 'warning'
        })
      } else if (this.multipleSelection.length > 1) {
        this.$notify({
          title: '提示',
          message: '由于需要上传销号凭证，请选择单条数据提交删除审核！',
          type: 'warning'
        })
      }
       // else{
       //   this.filterDataxhpz()
      // }
      else {
        this.$confirm('此操作将提交删除审核, 需要先上传销号凭证，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(action => {
          if (action === 'confirm') {
            this.filterDataxhpz()
            //this.uploadxhpzToDele();
            // for (let i = 0; i < this.multipleSelection.length; i++) {
            //   this.multipleSelection[i].ydbLx = '销号';
            // }
            // preApproveYdb(this.multipleSelection).then((res) => {
            //   _this.$notify({
            //     title: "提示",
            //     message: '提交删除审核成功!',
            //     type: "success",
            //   });
            // });
          }
        }).catch(() => {

        })
      }
    },

    xzdata (e) {
      let file = e.target.files[0]
      let filename = file.name.split('.')[
      file.name.split('.').length - 1
       ]

      let filenames = file.name
      let fileSize = file.size / 1024 / 1024 < 1000000

      if (fileSize) {
        if (filename != 'xlsx') {
          this.$notify({
            title: '提示',
            message: '请选择xls文件',
            type: 'success'
          })
          e.target.value = null
        } else {
          let formData = new FormData()
          formData.append('file', file)
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
              //"login-token": this.$store.state.logintoken,
            }
          } // 添加请求头
          this.flag = true
          this.startLoading()
          axios.post('/importfile/ydb/basic/zxdcimport', formData, config).then((res) => {
            clearInterval(this.timer) // 停止计时器
            this.loadingPercentage = 100
            // 延时 1 秒后执行关闭遮罩或其他操作
            setTimeout(() => {
              this.loadingVisible = false
            }, 1000)
            if (res.data.code == 200) {
              if (res.data.data != '' && res.data.data != null) {//导入成功并且有数据校验不合法的条目
                this.importErrorDialogVisible = true
                let responseData = res.data.data
                let tableData = []
                for (const key in responseData) {
                  if (Object.hasOwnProperty.call(responseData, key)) {
                    const value = responseData[key]
                    console.log('Key:', key)
                    console.log('Value:', value)
                    let obj = {
                      'code': key,
                      'reason': value
                    }
                    tableData.push(obj)
                  }
                }
                this.errordatas = tableData
              } else {//导入成功没有提示数据
                this.$notify({
                  title: '提示',
                  message: res.data.message,
                  type: 'success'
                })
              }
              let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                ydbName: this.objdata1
              }
              this.list(params)
              e.target.value = null
            } else {
              this.$notify({
                title: '提示',
                message: res.data.message,
                type: 'warning'
              })
              let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                ydbName: this.objdata1
              }
              this.list(params)
              e.target.value = null
            }
          }).catch((err) => {
            clearInterval(this.timer) // 停止计时器
            this.loadingPercentage = 100
            // 延时 1 秒后执行关闭遮罩或其他操作
            setTimeout(() => {
              this.loadingVisible = false
              // 关闭遮罩或执行其他操作
            }, 1000)
          })
        }
      } else {
        this.$message({
          message: '文件不能大于10M',
          type: 'success'
        })
        e.target.value = null
      }

    },
    xxYdbImportdata (e) {
      let file = e.target.files[0]
      let filename = file.name.split('.')[
      file.name.split('.').length - 1
       ]

      let filenames = file.name
      let fileSize = file.size / 1024 / 1024 < 1000000

      if (fileSize) {
        if (filename != 'xlsx') {
          this.$notify({
            title: '提示',
            message: '请选择xls文件',
            type: 'success'
          })
          e.target.value = null
        } else {
          console.log('this.$store.state.token', this.$store.state.token)
          let formData = new FormData()
          formData.append('file', file)
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data',
              'Access-Token': this.$store.state.token
            }
          }
          this.flag = true
          // 添加请求头
          this.startLoading()
          axios.post('/importfile/ydb/basic/importxxydbbasicinfo', formData, config).then((res) => {
            clearInterval(this.timer) // 停止计时器
            this.loadingPercentage = 100
            // 延时 1 秒后执行关闭遮罩或其他操作
            setTimeout(() => {
              this.loadingVisible = false
            }, 1000)
            if (res.data.code == 200) {
              if (res.data.data != '' && res.data.data != null) {//导入成功并且有数据校验不合法的条目
                this.importErrorDialogVisible = true
                let responseData = res.data.data
                let tableData = []
                for (const key in responseData) {
                  if (Object.hasOwnProperty.call(responseData, key)) {
                    const value = responseData[key]
                    console.log('Key:', key)
                    console.log('Value:', value)
                    let obj = {
                      'code': key,
                      'reason': value
                    }
                    tableData.push(obj)
                  }
                }
                this.errordatas = tableData
              } else {//导入成功没有提示数据
                this.$notify({
                  title: '提示',
                  message: res.data.message,
                  type: 'success'
                })
              }
              let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                ydbName: this.objdata1
              }
              this.list(params)
              e.target.value = null
            } else {
              this.$notify({
                title: '提示',
                message: res.data.message,
                type: 'warning'
              })
              let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                ydbName: this.objdata1
              }
              this.list(params)
              e.target.value = null
            }
          }).catch((err) => {
            clearInterval(this.timer) // 停止计时器
            this.loadingPercentage = 100
            // 延时 1 秒后执行关闭遮罩或其他操作
            setTimeout(() => {
              this.loadingVisible = false
              // 关闭遮罩或执行其他操作
            }, 1000)
          })
        }
      } else {
        this.$message({
          message: '文件不能大于10M',
          type: 'success'
        })
        e.target.value = null
      }

    },
    /**设置表头背景颜色 */
    rowClass ({
      rowIndex,
      columnIndex
    }) {
      if (rowIndex === 0) {
        if (columnIndex === 0) {
          return {
            background: '#bcc4ce',
            border: '1px solid #000',
            color: '#687080'
          }
        }
      }

      if (rowIndex === 1) {
        if (columnIndex <= 46) {
          return {
            background: '#bcc4ce',
            border: '1px solid #000',
            color: '#687080'
          }
        }
      }
      if (rowIndex === 2) {
        if (columnIndex <= 13) {
          return {
            background: '#bcc4ce',
            border: '1px solid #000',
            color: '#687080'
          }
        }
      }
      if (columnIndex === 1) {
        if (rowIndex === 0) {
          return {
            background: '#bcc4ce',
            border: '1px solid #000',
            color: '#687080'
          }
        }
      }

      if (rowIndex === 1) {
        if (columnIndex > 45) {
          return {
            background: '#b4d0f3',
            border: '1px solid #000',
            color: '#687080'
          }
        }
      }
      if (columnIndex === 2) {
        if (rowIndex === 0) {
          return {
            background: '#b4d0f3',
            border: '1px solid #000',
            color: '#687080'
          }
        }
      }
      if (rowIndex === 2) {
        if (columnIndex < 45) {
          return {
            background: '#b4d0f3',
            border: '1px solid #000',
            color: '#687080'
          }
        }
      }
    }

  }
}
</script>

<style scoped>
@import url("../../../common/css/mangementall.css");

.loading-overlay {
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

::v-deep .el-progress__text {
  font-size: 24px !important;
  color: rgb(30, 160, 225) !important;
}

::v-deep .el-progress-circle {
  width: 150px !important;
  height: 150px !important;
}

.tips_css {
  font-size: 24px;
  color: rgb(30, 160, 225)
}

.zblxtree {
  width: 230px;
  height: calc(100% - 80px);
  height: -webkit-calc(100% - 80px);
  height: -moz-calc(100% - 80px);
  background: #f7f7f7;
  border-radius: 6px;
  float: left;
  overflow: auto;
  padding: 15px;
}

.zblxtreeSty {
  background: #f7f7f7;
  border-radius: 6px;
}

.tablelist {
  width: 100%;
  height: calc(100% - 50px);
  height: -webkit-calc(100% - 50px);
  height: -moz-calc(100% - 50px);
  float: right;
  position: relative;
}

.tablelistbox {
  width: 100%;
  heigt: 100%;
}

.clsjTis {
  position: absolute;
  left: 0px;
  top: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  width: 335px;
  height: 210px;
  border: 1px solid #cccccc;
  background: #f7f7f7;
  border-radius: 6px;
  font-size: 16px;
}

.ycllxname {
  float: left;
  line-height: 30px;
  font-size: 14px;
  margin-left: 10px;
  margin-top: 10px;
}

.cllx-select {
  float: left;
  margin-top: 10px;
  width: 230px;
}

.btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.zzct {
  font-size: 20px;
  margin-right: 10px;
}

.import-s {
  float: right;
  position: relative;
  width: 100px;
  height: 28px;
  background: #409eff;
  margin-right: 10px;
  border-radius: 4px;
  margin-top: 11px;
  overflow: hidden;
}

.import-s p {
  position: absolute;
  width: 100%;
  line-height: 28px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
}

.import-s p span {
  margin-right: 5px;
}

.import-s input {
  width: 100%;
  height: 28px;
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.el-input__inner {
  height: 30px;
  line-height: 30px;
  color: #606266;

  font-size: 14px;
}
</style>
